import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import {
	CUSTOM_ELEMENTS_SCHEMA,
	LOCALE_ID,
	NgModule,
} from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import "hammerjs";

import { RoutingModule } from "./app-routing.module";
import { JamestownAppComponent } from "./app.component";
import { CoalescingComponentFactoryResolver } from "./core/components/coalescing-component-factory-resolver.component";

// FIREBASE
import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import { BrowserModule } from "@angular/platform-browser";
import { DeviceDetectorService } from "ngx-device-detector";
import { PageTitleService } from "./base/page-title/page-title.service";
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { environment } from "src/environments/environment";
import { JWT_OPTIONS, JwtModule } from "@auth0/angular-jwt";
import { SecurityHelper } from "./core/helpers/security.helper";
import { StoreModule } from "@ngrx/store";
import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpConfigInterceptor } from "@core/interceptors/httpconfig.interceptor";
import { ToastrModule } from "ngx-toastr";
import {QRCodeModule} from 'angularx-qrcode';
import { SpeedTestModule } from "ng-speed-test";
import { MatDialogModule } from "@angular/material/dialog";
registerLocaleData(localeEs, "es");

@NgModule({
	declarations: [JamestownAppComponent],
	imports: [
		HttpClientModule,
    MatDialogModule,
		BrowserModule,
    SpeedTestModule,
		RoutingModule,
    ToastrModule.forRoot(),
		BrowserAnimationsModule,
		QRCodeModule,
		provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
		provideFirestore(() => getFirestore()),
		JwtModule.forRoot({
			jwtOptionsProvider: {
				provide: JWT_OPTIONS,
				useFactory: (securityHelper: SecurityHelper) => {
					return {
						tokenGetter: () => {
							return securityHelper.getToken();
						},
						whitelistedDomains: securityHelper.getWhitelist(),
						blacklistedRoutes: securityHelper.getBlackList()
					};
				},
				deps: [SecurityHelper]
			}
		}),
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: true }),
		StoreModule.forRoot({}),
	],
	bootstrap: [JamestownAppComponent],
	providers: [
		PageTitleService,
		CoalescingComponentFactoryResolver,
		{ provide: LOCALE_ID, useValue: "en" },
		{
			provide: DeviceDetectorService,
		},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JamestownAppModule {
	constructor(coalescingResolver: CoalescingComponentFactoryResolver) {
		coalescingResolver.init();
	}
}
